// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".whiteboard-modal[data-v-71d36b9e] {\n  height: 100%;\n}\n.headlineText[data-v-71d36b9e] {\n  padding: 0px 0.5rem 0px 0px;\n  margin: 0px;\n}\n.headline[data-v-71d36b9e] {\n  position: absolute;\n  right: 1rem;\n  top: 0.5rem;\n  z-index: 10;\n  border-radius: 5px;\n}\n.content[data-v-71d36b9e] {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  padding: 0px !important;\n}", ""]);
// Exports
module.exports = exports;
